// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-menus-footer-menu----footer-menu-module---list---1QvYA","item":"src-components-menus-footer-menu----footer-menu-module---item---2nomC","link":"src-components-menus-footer-menu----footer-menu-module---link---3k7JJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/footer-menu/footer-menu.module.css
// module id = 166
// module chunks = 35783957827783 114276838955818